export const dummyAIgeneratedImages = [
  {
    "id": 1,
    "entity_id": 2,
    "image_type": "ai",
    "entity_type": "product",
    "image_name": "VKGL4350_upload-0d09fc61-12dd-4fe7-8225-24f7bdb0c649.png",
    "uri": "https://d48f7equ64qjl.cloudfront.net/static_files/ai_generated_images/VKGL4350_upload-0d09fc61-12dd-4fe7-8225-24f7bdb0c649.png",
    "platform": "aws",
    "status": "completed",
    "username": "faizan42",
    "submitted_on": "2025-02-18T12:22:45.774531",
    "time_updated": 1739881522816.7688,
    "threesixty_frames": null,
    "is360": false
  },
  {
    "id": 2,
    "entity_id": 2,
    "image_type": "ai",
    "entity_type": "product",
    "image_name": "upscale_fd3dbb9f-d76a-4a10-b5b5-0be37f08fada.png",
    "uri": "https://d48f7equ64qjl.cloudfront.net/static_files/ai_generated_images/upscale_fd3dbb9f-d76a-4a10-b5b5-0be37f08fada.png",
    "platform": "aws",
    "status": "completed",
    "username": "faizan42",
    "submitted_on": "2025-02-18T12:22:45.774531",
    "time_updated": 1739881522816.7688,
    "threesixty_frames": null,
    "is360": false
  },
  {
    "id": 3,
    "entity_id": 2,
    "image_type": "ai",
    "entity_type": "product",
    "image_name": "upscale_0782e580-d061-4230-831e-f40784cb3cc6 (1).png",
    "uri": "https://d48f7equ64qjl.cloudfront.net/static_files/ai_generated_images/upscale_0782e580-d061-4230-831e-f40784cb3cc6+(1).png",
    "platform": "aws",
    "status": "completed",
    "username": "faizan42",
    "submitted_on": "2025-02-18T12:22:45.774531",
    "time_updated": 1739881522816.7688,
    "threesixty_frames": null,
    "is360": false
  },
  {
    "id": 4,
    "entity_id": 2,
    "image_type": "ai",
    "entity_type": "product",
    "image_name": "unknown_upload-ef63def9-c46e-416a-a34c-78e1867a6e5c.png",
    "uri": "https://d48f7equ64qjl.cloudfront.net/static_files/ai_generated_images/unknown_upload-ef63def9-c46e-416a-a34c-78e1867a6e5c.png",
    "platform": "aws",
    "status": "completed",
    "username": "faizan42",
    "submitted_on": "2025-02-18T12:22:45.774531",
    "time_updated": 1739881522816.7688,
    "threesixty_frames": null,
    "is360": false
  },
  {
    "id": 5,
    "entity_id": 2,
    "image_type": "ai",
    "entity_type": "product",
    "image_name": "unknown_upload-eab442f4-ae11-42a9-a2a0-c197b4b8611a.png",
    "uri": "https://d48f7equ64qjl.cloudfront.net/static_files/ai_generated_images/unknown_upload-eab442f4-ae11-42a9-a2a0-c197b4b8611a.png",
    "platform": "aws",
    "status": "completed",
    "username": "faizan42",
    "submitted_on": "2025-02-18T12:22:45.774531",
    "time_updated": 1739881522816.7688,
    "threesixty_frames": null,
    "is360": false
  },
  {
    "id": 6,
    "entity_id": 2,
    "image_type": "ai",
    "entity_type": "product",
    "image_name": "unknown_upload-dee961fa-3afc-4ffb-a5ed-cce60a0d2240.png",
    "uri": "https://d48f7equ64qjl.cloudfront.net/static_files/ai_generated_images/unknown_upload-dee961fa-3afc-4ffb-a5ed-cce60a0d2240.png",
    "platform": "aws",
    "status": "completed",
    "username": "faizan42",
    "submitted_on": "2025-02-18T12:22:45.774531",
    "time_updated": 1739881522816.7688,
    "threesixty_frames": null,
    "is360": false
  },
  {
    "id": 7,
    "entity_id": 2,
    "image_type": "ai",
    "entity_type": "product",
    "image_name": "unknown_upload-521f8641-ffa8-414f-9d28-042d129f4a83.png",
    "uri": "https://d48f7equ64qjl.cloudfront.net/static_files/ai_generated_images/unknown_upload-521f8641-ffa8-414f-9d28-042d129f4a83.png",
    "platform": "aws",
    "status": "completed",
    "username": "faizan42",
    "submitted_on": "2025-02-18T12:22:45.774531",
    "time_updated": 1739881522816.7688,
    "threesixty_frames": null,
    "is360": false
  },
  {
    "id": 8,
    "entity_id": 2,
    "image_type": "ai",
    "entity_type": "product",
    "image_name": "Throw.png",
    "uri": "https://d48f7equ64qjl.cloudfront.net/static_files/ai_generated_images/Throw.png",
    "platform": "aws",
    "status": "completed",
    "username": "faizan42",
    "submitted_on": "2025-02-18T12:22:45.774531",
    "time_updated": 1739881522816.7688,
    "threesixty_frames": null,
    "is360": false
  },
  {
    "id": 9,
    "entity_id": 2,
    "image_type": "ai",
    "entity_type": "product",
    "image_name": "Sofa Banquet.png",
    "uri": "https://d48f7equ64qjl.cloudfront.net/static_files/ai_generated_images/Sofa Banquet.png",
    "platform": "aws",
    "status": "completed",
    "username": "faizan42",
    "submitted_on": "2025-02-18T12:22:45.774531",
    "time_updated": 1739881522816.7688,
    "threesixty_frames": null,
    "is360": false
  },
  {
    "id": 10,
    "entity_id": 2,
    "image_type": "ai",
    "entity_type": "product",
    "image_name": "Silverware.png",
    "uri": "https://d48f7equ64qjl.cloudfront.net/static_files/ai_generated_images/Silverware.png",
    "platform": "aws",
    "status": "completed",
    "username": "faizan42",
    "submitted_on": "2025-02-18T12:22:45.774531",
    "time_updated": 1739881522816.7688,
    "threesixty_frames": null,
    "is360": false
  },
  {
    "id": 11,
    "entity_id": 2,
    "image_type": "ai",
    "entity_type": "product",
    "image_name": "Rug.png",
    "uri": "https://d48f7equ64qjl.cloudfront.net/static_files/ai_generated_images/Rug.png",
    "platform": "aws",
    "status": "completed",
    "username": "faizan42",
    "submitted_on": "2025-02-18T12:22:45.774531",
    "time_updated": 1739881522816.7688,
    "threesixty_frames": null,
    "is360": false
  },
  {
    "id": 12,
    "entity_id": 2,
    "image_type": "ai",
    "entity_type": "product",
    "image_name": "image (34).png",
    "uri": "https://d48f7equ64qjl.cloudfront.net/static_files/ai_generated_images/image (34).png",
    "platform": "aws",
    "status": "completed",
    "username": "faizan42",
    "submitted_on": "2025-02-18T12:22:45.774531",
    "time_updated": 1739881522816.7688,
    "threesixty_frames": null,
    "is360": false
  },
  {
    "id": 13,
    "entity_id": 2,
    "image_type": "ai",
    "entity_type": "product",
    "image_name": "Holiday Garland.png",
    "uri": "https://d48f7equ64qjl.cloudfront.net/static_files/ai_generated_images/Holiday+Garland.png",
    "platform": "aws",
    "status": "completed",
    "username": "faizan42",
    "submitted_on": "2025-02-18T12:22:45.774531",
    "time_updated": 1739881522816.7688,
    "threesixty_frames": null,
    "is360": false
  },
  {
    "id": 14,
    "entity_id": 2,
    "image_type": "ai",
    "entity_type": "product",
    "image_name": "Glassware.png",
    "uri": "https://d48f7equ64qjl.cloudfront.net/static_files/ai_generated_images/Glassware.png",
    "platform": "aws",
    "status": "completed",
    "username": "faizan42",
    "submitted_on": "2025-02-18T12:22:45.774531",
    "time_updated": 1739881522816.7688,
    "threesixty_frames": null,
    "is360": false
  },
  {
    "id": 15,
    "entity_id": 2,
    "image_type": "ai",
    "entity_type": "product",
    "image_name": "Cushion.png",
    "uri": "https://d48f7equ64qjl.cloudfront.net/static_files/ai_generated_images/Cushion.png",
    "platform": "aws",
    "status": "completed",
    "username": "faizan42",
    "submitted_on": "2025-02-18T12:22:45.774531",
    "time_updated": 1739881522816.7688,
    "threesixty_frames": null,
    "is360": false
  },
  {
    "id": 16,
    "entity_id": 2,
    "image_type": "ai",
    "entity_type": "product",
    "image_name": "Copy of Dining Table.png",
    "uri": "https://d48f7equ64qjl.cloudfront.net/static_files/ai_generated_images/Copy of Dining Table.png",
    "platform": "aws",
    "status": "completed",
    "username": "faizan42",
    "submitted_on": "2025-02-18T12:22:45.774531",
    "time_updated": 1739881522816.7688,
    "threesixty_frames": null,
    "is360": false
  },
  {
    "id": 17,
    "entity_id": 2,
    "image_type": "ai",
    "entity_type": "product",
    "image_name": "Copy of 7228-75001-99.png",
    "uri": "https://d48f7equ64qjl.cloudfront.net/static_files/ai_generated_images/Copy of 7228-75001-99.png",
    "platform": "aws",
    "status": "completed",
    "username": "faizan42",
    "submitted_on": "2025-02-18T12:22:45.774531",
    "time_updated": 1739881522816.7688,
    "threesixty_frames": null,
    "is360": false
  },
  {
    "id": 18,
    "entity_id": 2,
    "image_type": "ai",
    "entity_type": "product",
    "image_name": "Copy of 5805-90115-99 (1)_Edited.png",
    "uri": "https://d48f7equ64qjl.cloudfront.net/static_files/ai_generated_images/Copy of 5805-90115-99 (1)_Edited.png",
    "platform": "aws",
    "status": "completed",
    "username": "faizan42",
    "submitted_on": "2025-02-18T12:22:45.774531",
    "time_updated": 1739881522816.7688,
    "threesixty_frames": null,
    "is360": false
  },
  {
    "id": 19,
    "entity_id": 2,
    "image_type": "ai",
    "entity_type": "product",
    "image_name": "Bowls.png",
    "uri": "https://d48f7equ64qjl.cloudfront.net/static_files/ai_generated_images/Bowls.png",
    "platform": "aws",
    "status": "completed",
    "username": "faizan42",
    "submitted_on": "2025-02-18T12:22:45.774531",
    "time_updated": 1739881522816.7688,
    "threesixty_frames": null,
    "is360": false
  },
  {
    "id": 20,
    "entity_id": 2,
    "image_type": "ai",
    "entity_type": "product",
    "image_name": "Blue Glassware.png",
    "uri": "https://d48f7equ64qjl.cloudfront.net/static_files/ai_generated_images/Blue Glassware.png",
    "platform": "aws",
    "status": "completed",
    "username": "faizan42",
    "submitted_on": "2025-02-18T12:22:45.774531",
    "time_updated": 1739881522816.7688,
    "threesixty_frames": null,
    "is360": false
  },
  {
    "id": 21,
    "entity_id": 2,
    "image_type": "ai",
    "entity_type": "product",
    "image_name": "base_buttercup_db590470-ffd9-42d8-a716-89b65d004538.png",
    "uri": "https://d48f7equ64qjl.cloudfront.net/static_files/ai_generated_images/base_buttercup_db590470-ffd9-42d8-a716-89b65d004538.png",
    "platform": "aws",
    "status": "completed",
    "username": "faizan42",
    "submitted_on": "2025-02-18T12:22:45.774531",
    "time_updated": 1739881522816.7688,
    "threesixty_frames": null,
    "is360": false
  },
  {
    "id": 22,
    "entity_id": 2,
    "image_type": "ai",
    "entity_type": "product",
    "image_name": "base_buttercup_b9fa35bf-35a0-47e7-b259-4a598d0a6dc9.png",
    "uri": "https://d48f7equ64qjl.cloudfront.net/static_files/ai_generated_images/base_buttercup_b9fa35bf-35a0-47e7-b259-4a598d0a6dc9.png",
    "platform": "aws",
    "status": "completed",
    "username": "faizan42",
    "submitted_on": "2025-02-18T12:22:45.774531",
    "time_updated": 1739881522816.7688,
    "threesixty_frames": null,
    "is360": false
  },
  {
    "id": 23,
    "entity_id": 2,
    "image_type": "ai",
    "entity_type": "product",
    "image_name": "base_buttercup_a2788997-9d2f-4086-8c71-70c19a410d07.png",
    "uri": "https://d48f7equ64qjl.cloudfront.net/static_files/ai_generated_images/base_buttercup_a2788997-9d2f-4086-8c71-70c19a410d07.png",
    "platform": "aws",
    "status": "completed",
    "username": "faizan42",
    "submitted_on": "2025-02-18T12:22:45.774531",
    "time_updated": 1739881522816.7688,
    "threesixty_frames": null,
    "is360": false
  },
  {
    "id": 24,
    "entity_id": 2,
    "image_type": "ai",
    "entity_type": "product",
    "image_name": "base_buttercup_00829c76-f387-4b11-914b-ff0fa58c02a4.png",
    "uri": "https://d48f7equ64qjl.cloudfront.net/static_files/ai_generated_images/base_buttercup_00829c76-f387-4b11-914b-ff0fa58c02a4.png",
    "platform": "aws",
    "status": "completed",
    "username": "faizan42",
    "submitted_on": "2025-02-18T12:22:45.774531",
    "time_updated": 1739881522816.7688,
    "threesixty_frames": null,
    "is360": false
  },
  {
    "id": 25,
    "entity_id": 2,
    "image_type": "ai",
    "entity_type": "product",
    "image_name": "base_buttercup_602ff752-c92f-4d3c-8aea-8037e75fb91e.png",
    "uri": "https://d48f7equ64qjl.cloudfront.net/static_files/ai_generated_images/base_buttercup_602ff752-c92f-4d3c-8aea-8037e75fb91e.png",
    "platform": "aws",
    "status": "completed",
    "username": "faizan42",
    "submitted_on": "2025-02-18T12:22:45.774531",
    "time_updated": 1739881522816.7688,
    "threesixty_frames": null,
    "is360": false
  },
  {
    "id": 26,
    "entity_id": 2,
    "image_type": "ai",
    "entity_type": "product",
    "image_name": "base_buttercup_28d48d6c-c232-4d6e-a99b-37d68b57e7c4.png",
    "uri": "https://d48f7equ64qjl.cloudfront.net/static_files/ai_generated_images/base_buttercup_28d48d6c-c232-4d6e-a99b-37d68b57e7c4.png",
    "platform": "aws",
    "status": "completed",
    "username": "faizan42",
    "submitted_on": "2025-02-18T12:22:45.774531",
    "time_updated": 1739881522816.7688,
    "threesixty_frames": null,
    "is360": false
  },
  {
    "id": 27,
    "entity_id": 2,
    "image_type": "ai",
    "entity_type": "product",
    "image_name": "base_buttercup_7b197b5e-c651-4792-8368-6d2e0b1d7284.png",
    "uri": "https://d48f7equ64qjl.cloudfront.net/static_files/ai_generated_images/base_buttercup_7b197b5e-c651-4792-8368-6d2e0b1d7284.png",
    "platform": "aws",
    "status": "completed",
    "username": "faizan42",
    "submitted_on": "2025-02-18T12:22:45.774531",
    "time_updated": 1739881522816.7688,
    "threesixty_frames": null,
    "is360": false
  },
  {
    "id": 28,
    "entity_id": 2,
    "image_type": "ai",
    "entity_type": "product",
    "image_name": "base_buttercup_3ee65a2a-d55a-49ce-afed-ee0657e27d5a.png",
    "uri": "https://d48f7equ64qjl.cloudfront.net/static_files/ai_generated_images/base_buttercup_3ee65a2a-d55a-49ce-afed-ee0657e27d5a.png",
    "platform": "aws",
    "status": "completed",
    "username": "faizan42",
    "submitted_on": "2025-02-18T12:22:45.774531",
    "time_updated": 1739881522816.7688,
    "threesixty_frames": null,
    "is360": false
  },
  {
    "id": 29,
    "entity_id": 2,
    "image_type": "ai",
    "entity_type": "product",
    "image_name": "base_buttercup_1a16d11b-3087-4b1c-9b97-a39f56365d6d.png",
    "uri": "https://d48f7equ64qjl.cloudfront.net/static_files/ai_generated_images/base_buttercup_1a16d11b-3087-4b1c-9b97-a39f56365d6d.png",
    "platform": "aws",
    "status": "completed",
    "username": "faizan42",
    "submitted_on": "2025-02-18T12:22:45.774531",
    "time_updated": 1739881522816.7688,
    "threesixty_frames": null,
    "is360": false
  },
  {
    "id": 30,
    "entity_id": 2,
    "image_type": "ai",
    "entity_type": "product",
    "image_name": "718cc274-e222-4069-91d5-44ee5efc41c8_inspiration.png",
    "uri": "https://d48f7equ64qjl.cloudfront.net/static_files/ai_generated_images/718cc274-e222-4069-91d5-44ee5efc41c8_inspiration.png",
    "platform": "aws",
    "status": "completed",
    "username": "faizan42",
    "submitted_on": "2025-02-18T12:22:45.774531",
    "time_updated": 1739881522816.7688,
    "threesixty_frames": null,
    "is360": false
  }
]